import http, { url } from '../../http'

const API_URL = "copasst-act"

class CopasstActAPI {

  async saveAct(act) {
    const response = await http(`${API_URL}/save`, 'POST', act)
    return response || null
  }

  async updateAct(copasstID, act) {
    const response = await http(`${API_URL}/update/${copasstID}`, 'PUT', act)
    return response || null
  }

  async getAct(companyID) {
    const response = await http(`${API_URL}/companies/candidates/${companyID}`, 'GET')
    return response || null
  }

  async getLast(companyID) {
    const response = await http(`${API_URL}/show-recent-act/${companyID}`)
    return response
  }

/*   async getRecent(companyID) {
    const response = await http(`${API_URL}/recent-act-appointed/${companyID}`)
    return response
  } */

  async getRecent(companyID) {
    const response = await http(`${API_URL}/last-act-appointed/${companyID}`)
    return response
  }

  async getEmployee(companyID) {
    const response = await http(`employee/copasst/count/${companyID}`)
    return response
  }

  async getRecentVigia(companyID) {
    const response = await http(`${API_URL}/recent-act-appointed/${companyID}`)
    return response
  }

  async getRecentVigia2(companyID) {
    const response = await http(`${API_URL}/last-act-vigia/${companyID}`)
    return response
  }

  async getActById(copasstID) {
    const response = await http(`${API_URL}/acta_empleados/${copasstID}`, 'GET')
    return response.Copasst.data || null
  }

  getConformationAct(actID) {
    let user = JSON.parse(localStorage.getItem('user'))
    if (user.token) {
      return url(`copasst-candidate/downloadpdf/${actID}?&access_token=${user.token}`, 'POST')
    }
  }

  // Acta de Conformación COPASST branded: la app genera el PDF (logo + control + firma del encargado).
  pdfUrl(actID) {
    return url(`copasst-candidate/${actID}/pdf`)
  }

  async sign(actID, payload) {
    return await http(`copasst-candidate/${actID}/sign`, 'POST', payload)
  }

  async getConformacionStatus(actID) {
    return await http(`copasst-candidate/${actID}/conformacion-status`, 'GET')
  }

}

export default new CopasstActAPI()